import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { Option } from "~/components/Form/components/SelectMenu/SelectMenu";
import {
  BASE_MEMBERS_ROLES,
  MemberRoleGroupLabel,
} from "~/components/Members/const";

interface Props {
  onDelete: (roleMrn: string) => void;
  roles: Option[];
}

const BASE_ROLE_VALUES = new Set(BASE_MEMBERS_ROLES.map((role) => role.value));
const GROUP_ORDER = [MemberRoleGroupLabel.Base, MemberRoleGroupLabel.Detailed];

export const MembersRolesList = ({ onDelete, roles }: Props) => {
  const groupedRoles = roles.reduce<Record<string, Option[]>>((acc, role) => {
    const groupLabel = BASE_ROLE_VALUES.has(role.value)
      ? MemberRoleGroupLabel.Base
      : MemberRoleGroupLabel.Detailed;

    acc[groupLabel] = acc[groupLabel] ? [...acc[groupLabel], role] : [role];
    return acc;
  }, {});

  const orderedGroups = GROUP_ORDER.filter(
    (label) => groupedRoles[label]?.length,
  );

  return (
    <Box>
      {orderedGroups.map((groupLabel) => (
        <Box key={groupLabel} sx={{ mb: 2 }}>
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 600, mb: 0.5, textTransform: "uppercase" }}
          >
            {groupLabel}
          </Typography>
          <List disablePadding>
            {groupedRoles[groupLabel]?.map((role) => (
              <ListItem
                key={role.value}
                sx={{
                  display: "inline-flex",
                  gap: 2,
                  "&::before": {
                    content: '"•"',
                    position: "absolute",
                    left: 0,
                    top: "50%",
                    transform: "translateY(-50%)",
                    fontSize: "1.25rem",
                    color: "text.primary",
                  },
                }}
              >
                <ListItemText
                  primary={role.label}
                  sx={{ display: "inline-flex", flex: "unset" }}
                />
                <IconButton
                  size="small"
                  onClick={() => {
                    onDelete(role.value);
                  }}
                  data-testid="delete-role-button"
                >
                  <DeleteIcon fontSize="inherit" color="error" />
                </IconButton>
              </ListItem>
            ))}
          </List>
        </Box>
      ))}
    </Box>
  );
};
